import { useEffect, useState } from "react";
import { PinPad } from "@/components/PinPad";
import { getPinConfig, verifyPin } from "@/lib/pin";

export function PinGuard({
  children,
  title = "Contenido protegido",
  description = "Introduce el PIN de acceso para continuar.",
}) {
  const [pinConfig] = useState(() => getPinConfig());
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (!pinConfig.configured || pin.length !== pinConfig.length) {
      return;
    }

    let active = true;
    setChecking(true);

    verifyPin(pin)
      .then((valid) => {
        if (!active) return;
        if (valid) {
          setUnlocked(true);
          return;
        }
        setError("El PIN no es correcto");
        setPin("");
        setChecking(false);
      })
      .catch(() => {
        if (!active) return;
        setError("No se ha podido comprobar el PIN");
        setPin("");
        setChecking(false);
      });

    return () => {
      active = false;
    };
  }, [pin, pinConfig]);

  if (!pinConfig.configured || unlocked) return children;

  return (
    <div className="absolute inset-0 flex items-center justify-center overflow-y-auto bg-neutral-100 px-4 py-6 select-none">
      <div className="flex w-full max-w-xs flex-col items-center">
        <div className="text-center">
          <h1 className="text-xl font-semibold text-neutral-900">{title}</h1>
          <p className="mx-auto mt-2 max-w-[16rem] text-sm leading-5 text-neutral-500">
            {description}
          </p>
        </div>

        <div className="mt-7 w-full">
          <PinPad
            value={pin}
            onChange={(value) => {
              setError("");
              setPin(value);
            }}
            maxLength={pinConfig.length}
            disabled={checking}
            loading={checking}
            message={error || `PIN de ${pinConfig.length} dígitos`}
            error={Boolean(error)}
          />
        </div>

        <p className="mt-5 text-center text-xs text-neutral-400">
          Puedes cambiar el PIN desde Ajustes → Seguridad.
        </p>
      </div>
    </div>
  );
}
